import { FC } from 'react';
import { createUseStyles } from 'react-jss';
import { avatarTone, initialsFor } from './agencyChartTheme';

const useStyles = createUseStyles({
    avatar: {
        display: 'inline-flex',
        alignItems: 'center',
        justifyContent: 'center',
        flexShrink: 0,
        borderRadius: '50%',
        color: '#fff',
        fontWeight: 600,
        letterSpacing: '0.01em',
        // Initials on a mid-tone circle are a hair too heavy at full weight against the surrounding
        // text, and the ring lifts the circle off a card of the same family of colours.
        boxShadow: 'inset 0 0 0 1px rgba(255, 255, 255, 0.22)'
    }
});

/**
 * A client's initials on a circle, used wherever the tab lists people.
 *
 * Rows of names alone read as a spreadsheet; a caseload tool should look like it is about people,
 * and the avatar is also the fastest way to re-find the same client further down the page. The tone
 * is derived from the client's id rather than their name so it survives a corrected spelling.
 *
 * The initials carry mp-mask: two letters is weak identification on their own, but inside a small
 * caseload they are enough to name someone, and session replay has no reason to hold them.
 */
export const ClientAvatar: FC<{ careMapId: string; clientName: string; size?: number }> = ({
    careMapId,
    clientName,
    size = 28
}) => {
    const classes = useStyles();

    return (
        <span
            className={classes.avatar}
            data-id="client-avatar"
            aria-hidden="true"
            style={{
                width: size,
                height: size,
                background: avatarTone(careMapId),
                fontSize: Math.round(size * 0.4)
            }}
        >
            <span className="mp-mask">{initialsFor(clientName)}</span>
        </span>
    );
};
